import type { AxiosResponse } from 'axios';

import { type Status } from '../../../License/types/enums';

import { request } from '../../../../services/requestService';

import { type IRestriction, type LicenseTypeNature } from '../../../../types';
import { PAGINATION_LIMIT, type SortDirection } from '../../../../constants';
import { type SearchResult } from '../../../../@types/serviceTypes';
import { type ILicenseSearchResult } from '../../store/types';

import { convertRestrictions } from '../../store/dataAdapter';

export interface IGetLicensesParams {
  page: number;
  selectFields: string[];
  excludedStatuses: Status[];
  sortByFields: {
    field: string;
    mode: SortDirection;
  };
  restrictions: Record<string, IRestriction>;
  licenseTypeNature?: LicenseTypeNature;
  pageSize?: number;
}

export const getLicenses = ({
  page,
  selectFields,
  excludedStatuses,
  sortByFields,
  restrictions,
  licenseTypeNature,
  pageSize = PAGINATION_LIMIT,
}: IGetLicensesParams): Promise<AxiosResponse<SearchResult<ILicenseSearchResult>>> => {
  const finalRestrictions = convertRestrictions(restrictions, excludedStatuses, licenseTypeNature);

  return request({
    method: 'POST',
    url: 'lpco/search',
    data: {
      offset: (page - 1) * pageSize,
      max: pageSize,
      selectFields,
      sortByFields: {
        [sortByFields.field]: sortByFields.mode,
      },
      restrictBy: 'AND',
      restrictions: finalRestrictions,
    },
  });
};
